import React from "react";
import { useDispatch } from "react-redux";
import { ESIGN_DOCUMENT_TYPE } from "../../../constants/commonConstants";
import Wrapper from "./esignButtons.styles";
import Button from "@components/button";
import actions from "@redux/esign/actions";

const EsignButtons = ({esignStep, stepRange, activeDocumentType, handleDocumentNavigation}) => {
    const dispatch = useDispatch();

    const handleBackButton = (esignStep, stepRange) => {
        const minPage = stepRange[0];
        if (esignStep > minPage) {
            dispatch(actions.currentEsignPageIndex(esignStep - 1));
            if (activeDocumentType.type === ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE.type) {
                handleDocumentNavigation(ESIGN_DOCUMENT_TYPE.CONTRACT)
            }
            if (esignStep === 3) {
                handleDocumentNavigation(ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE)
            }
        } else {
            return;
        }
    };

    const handleForwardButton = (esignStep, stepRange) => {
        const maxPage = stepRange[1];
        if (esignStep < maxPage) {
            if ((esignStep === 1) && (activeDocumentType.type === ESIGN_DOCUMENT_TYPE.CONTRACT.type)) {
                handleDocumentNavigation(ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE)
                  dispatch(actions.currentEsignPageIndex(esignStep + 1));
            } else {
                dispatch(actions.currentEsignPageIndex(esignStep + 1));
            }
        } else {
            return;
        }
    };

    const continueButtonText = (esignStep === 2) && (activeDocumentType.type === ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE.type) ? "Ready to Esign" : "Continue";
    const showBackButton = [1, 2, 3].includes(esignStep);
    const showContinueButton = [0, 1, 2].includes(esignStep);

    return (
        <Wrapper $esignstep={esignStep}>
            {showBackButton && <Button className="esign-back" buttonText="<" onClick={()=> handleBackButton(esignStep, stepRange)}>{` Back`}</Button>}
            {showContinueButton && <Button className="esign-continue" buttonText={continueButtonText} onClick={()=> handleForwardButton(esignStep, stepRange)}>{` >`}</Button>}
        </Wrapper>
    )
}

export default EsignButtons;